export enum ERROR_TYPE {
    UNSUPPORTED_LANGUAGE = 'UnsupportedLanguageError',
    CMS_ITEM_NOT_FOUND = 'CMSItemNotFoundError',
}
